<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <!-- excel btn code -->
      <v-row dense>
        <v-col cols="12" sm="6" md="6">
          <v-btn
            rounded
            color="success"
            outlined
            @click="fnExcelReport('my-table-id', 'InstallmentReport')"
            :loading="loader"
            ><v-icon color="success">mdi-export</v-icon>Export</v-btn
          >
        </v-col>
      </v-row>
      <v-col cols="12" sm="12" md="12" v-if="data_list != ''">
        <div id="my-table-id">
          <v-simple-table dense class="elevation-1">
            <thead>
              <tr>
                <td
                  :colspan="component_length + 8 + ay_header.length"
                  style="text-transform: uppercase"
                >
                  FEE SUMMARY OF {{ section_new }} {{ ay }}
                </td>
              </tr>
              <tr>
                <td class="">Sr. No.</td>
                <td class="">Standard</td>
                <td class="">Strength</td>
                <td class="">Old Fee Recd</td>
                <td class="" v-for="(header, index) in component" :key="index">
                  {{ header }}
                </td>
                <td class="">Total Collected</td>
                <td class="">Total Fee {{ ay }}</td>
                <td class="">Balance {{ ay }}</td>
                <td class="" v-for="(header, index) in ay_header" :key="index">
                  {{ header }}
                </td>
                <td class="">Total O/s</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(l, index) in data_list" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ l.stadnard }}</td>
                <td>{{ l.strength }}</td>
                <td>{{ l.all_total_outstanding_paid }}</td>
                <td
                  v-for="(header, index) in l.installment_amount"
                  :key="index"
                >
                  {{ header[0] }}
                </td>
                <td>{{ l.all_total_paid }}</td>
                <td>{{ l.all_total_amount }}</td>
                <td>{{ l.all_total_remaining }}</td>
                <td
                  v-for="(header, index) in l.outstanding_collection"
                  :key="index"
                >
                  {{ header }}
                </td>
                <td>{{ l.overallbalance }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>{{ total_strength }}</td>
                <td>{{ total_amount_outstanding_paid }}</td>
                <td v-for="(header, index) in comp_list_total" :key="index">
                  {{ header }}
                </td>
                <td>{{ total_amount_paid }}</td>
                <td>{{ total_collection }}</td>
                <td>{{ total_amount_remaining }}</td>
                <td v-for="(header, index) in ay_total" :key="index">
                  {{ header }}
                </td>
                <td>{{ overall_collection }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-col>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {},
  data() {
    return {
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      search: null,
      installment_details: [],
      dialog: false,
      std_id: null,
      ay_std_div_list: null,
      sel_ay_data: null,
      ay_id: null,
      section_list: null,
      section_new: null,
      show: false,
      total_strength: [],
      total_collection: [],
      total_amount_paid: [],
      total_amount_remaining: [],
      section: null,
      ay: null,
      data_list: [],
      component: null,
      component_length: null,
      comp_list_total: [],
      org: null,
      status: null,
      ay_header: null,
      total_amount_outstanding_remaining: null,
      ay_total: [],
      total_amount_outstanding_paid: null,
      overall_collection: null,
    };
  },
  watch: {
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  methods: {
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    main() {
      const formData = {
        ay: this.sel_ay_data,
        section: this.section,
        org: this.org,
        status: this.status,
      };
      this.overlay = true;
      axios
        .post("/ZealExamination/installmentDetailedReport", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.data_list = res.data.data_list;
            this.total_strength = res.data.total_strength;
            this.total_collection = res.data.total_collection;
            this.total_amount_paid = res.data.total_amount_paid;
            this.total_amount_remaining = res.data.total_amount_remaining;
            this.component = res.data.component;
            this.component_length = this.component.length;
            this.section_new = res.data.section;
            this.ay = res.data.ay;
            this.overlay = false;
            this.comp_list_total = res.data.comp_list_total;
            this.ay_header = res.data.ay_header;
            this.total_amount_outstanding_remaining =
              res.data.total_amount_outstanding_remaining;
            this.ay_total = res.data.ay_total;
            this.total_amount_outstanding_paid =
              res.data.total_amount_outstanding_paid;
            this.overall_collection = res.data.overall_collection;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    this.sel_ay_data = localStorage.getItem("setay");
    this.section = localStorage.getItem("setsection");
    this.org = localStorage.getItem("setorg");
    this.status = localStorage.getItem("setstatus");
    this.main();
  },
};
</script>
<style scoped>
.text-color {
  font-weight: bold;
  color: red;
}
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
  }
  td + td,
  th + th {
    width: auto;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
